import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { AboutusComponent } from './components/page/aboutus/aboutus.component';
import { ContactsComponent } from './components/page/contacts/contacts.component';
import { PrivacyComponent } from './components/page/privacy/privacy.component';
import { TermsComponent } from './components/page/terms/terms.component';
import { HelpComponent } from './components/page/help/help.component';
import { FeedbackComponent } from './components/page/feedback/feedback.component';
import { PartnerComponent } from './components/page/partner/partner.component';
import { HowtoComponent } from './components/page/howto/howto.component';
import { InvestorsComponent } from './components/page/investors/investors.component';
import { OffersComponent } from './components/offers/offers.component';
import { GoogleReserveComponent } from './components/page/google-reserve/google-reserve.component';

const listingMapRegex = /[a-zA-Zа-яА-Я0-9.&!]+_[0-9]+\/(map)/;

const regexMatcherListingMap = (url: UrlSegment[]) => {
  let index = 0;
  let map = false;

  if (url.length == 2 && url[1].path.match(listingMapRegex)) {
    index = 1;
  }

  if (url.length == 2) {
    map = url[1].path === 'map';
  }

  // if (url.length > 2) {
  //   map = url[2].path === 'map';
  // }

  let page = 'undefined' != typeof url[index + 1] ? url[index + 1].path : '1';

  return url.length >= 2 && map
    ? {
      consumed: url,
      posParams: {
        categoryId: new UrlSegment(url[index].path.split("_")[1], {}),
        page: new UrlSegment(page, {})
      }
    }
    : null;
};

const listingRegex = /[a-zA-Zа-яА-Я0-9.&!]+_[0-9]+\/?/;

const regexMatcherListing = (url: UrlSegment[]) => {
  let index = 0;
  if (url.length >= 2 && url[1].path.match(listingRegex)) {
    index = 1;
  }

  let page = 'undefined' != typeof url[index + 1] ? url[index + 1].path : '1';

  return url[index].path.match(listingRegex)
    ? {
      consumed: url,
      posParams: {
        categoryId: new UrlSegment(url[index].path.split("_")[1], {}),
        page: new UrlSegment(page, {})
      }
    }
    : null;
};

const profileRegex = /\d{1,4}\/?/;

const regexMatcherProfile = (url: UrlSegment[]) => {
  return url[0].path.match(profileRegex)
    ? {
      consumed: url,
      posParams: {
        profileId: new UrlSegment(url[0].path, {})
      }
    }
    : null;
};

const routes: Routes = [
  {
    path: '',
    resolve: {
    },
    loadChildren: () => import('./components/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'page/aboutus',
    component: AboutusComponent,
  },
  {
    path: 'page/googlereserve',
    component: GoogleReserveComponent
  },
  {
    path: 'page/privacy',
    component: PrivacyComponent,
  },
  {
    path: 'page/partner',
    component: PartnerComponent,
  },
  {
    path: 'page/investors',
    component: InvestorsComponent,
  },
  {
    path: 'en/page/investors',
    component: InvestorsComponent,
  },
  {
    path: 'page/contacts',
    component: ContactsComponent,
  },
  {
    path: 'page/terms',
    component: TermsComponent,
  },
  {
    path: 'page/help',
    component: HelpComponent,
  },
  {
    path: 'page/feedback',
    component: FeedbackComponent,
  },
  {
    path: 'page/howto',
    component: HowtoComponent,
  },
  {
    path: 'page/test',
    component: OffersComponent,
  },
  {
    matcher: regexMatcherListingMap,
    loadChildren: () => import('./components/listing-map/listing-map.module').then((m) => m.ListingMapModule),
  },
  {
    matcher: regexMatcherListing,
    loadChildren: () => import('./components/listing/listing.module').then((m) => m.ListingModule),
  },
  {
    path: 'football',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/football',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'pushachi',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/pushachi',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'nikulden',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/nikulden',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'halloween',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/halloween',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'imen_den',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/imen_den',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: '14ti',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/14ti',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: '8mart',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/8mart',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'abiturienti',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/abiturienti',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'koleda',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/koleda',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'nova-godina',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/nova-godina',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'osmi-dekemvri',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/osmi-dekemvri',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'firmeni_partita',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: 'en/firmeni_partita',
    loadChildren: () => import('./components/special-offers/special-offers.module').then((m) => m.SpecialOffersModule),
  },
  {
    path: '14ti-fevruari',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/14ti-fevruari',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: '8mi-mart',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/8mi-mart',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'osmi_dekemvri',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/osmi_dekemvri',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'abiturienti-all',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/abiturienti-all',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'obedno.menu',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/obedno.menu',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'firmeni.partita',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/firmeni.partita',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'nova_godina',
    // redirectTo: 'nova-godina'
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'en/nova_godina',
    // redirectTo: 'en/nova-godina',
    loadChildren: () => import('./components/offers/offers.module').then((m) => m.OffersModule),
  },
  {
    path: 'top50',
    loadChildren: () => import('./components/top-listing/top-listing.module').then((m) => m.TopListingModule),
  },
  {
    path: 'en/top50',
    loadChildren: () => import('./components/top-listing/top-listing.module').then((m) => m.TopListingModule),
  },
  {
    path: 'search',
    loadChildren: () => import('./components/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'en/search',
    loadChildren: () => import('./components/search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'categories',
    loadChildren: () => import('./components/categories-list/categories-list.module').then((m) => m.CategoriesListModule),
  },
  {
    path: 'en/categories',
    loadChildren: () => import('./components/categories-list/categories-list.module').then((m) => m.CategoriesListModule),
  },
  {
    path: 'en/listing',
    loadChildren: () => import('./components/listing/listing.module').then((m) => m.ListingModule),
  },
  {
    path: ":profileId",
    loadChildren: () => import('./components/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: "en/:profileId",
    loadChildren: () => import('./components/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: '**',
    loadChildren: () => import('./components/not-found/not-found.module').then((m) => m.NotFoundModule),
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabledBlocking',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
